class MetafieldsOpts {

  static INIT_CLASS = 'js-metafields-opts--initialised';

  constructor(container) {
    this.container = typeof container === 'string' ? document.querySelector(container) : container;
    this.atcForm = this.container.closest('.product__section-content').querySelector('form[action*="/cart/add"].product__form-buttons');
    this.init();
  }

  init() {
    if (this.container.classList.contains(MetafieldsOpts.INIT_CLASS)) return;

    this.container.style.display = 'block';

    const firstInput = this.container.querySelector('input');
    const formInput = this.atcForm.querySelector(`input[name="properties[${firstInput.dataset.label}]"]`);

    if (formInput) {
      formInput.value = firstInput.value;
    } else {
      console.warn('MetafieldsOpts: ATC form input not found', this.container, this.atcForm);
      return;
    }

    this.container.querySelectorAll('label').forEach((label) => {
      label.addEventListener('click', (e) => {
        const input = e.currentTarget.closest('div').querySelector('input');
        this.container.querySelector('.swatches__option-name span').textContent = input.value;
        this.atcForm.querySelector(`input[name="properties[${input.dataset.label}]"]`).value = input.value;
      });
    });

    this.container.classList.add(MetafieldsOpts.INIT_CLASS);
  }

}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swatches__metafields').forEach((el) => new MetafieldsOpts(el));
});


/*
 *  Product Template Accordions
 *    Product Template Accordions (aka Tabs on desktop)
 *
 *  Version:
 *    1.0.0 - 2019/04/30
 */
function ProductTemplateAccordions(container) {
  this.container = typeof container === 'string' ? document.querySelector(container) : container;
  this.titles = this.container.querySelectorAll('[data-product-accordion-title]');
  this.bodies = this.container.querySelectorAll('[data-product-accordion-body]');

  this.container.addEventListener('click', this.onTitleClick.bind(this));
}

ProductTemplateAccordions.prototype = {
  onTitleClick: function(e) {
    const target = e.target.closest('[data-product-accordion-title]');
    
    if (!target) return;

    const body = target.nextElementSibling;
    const isExpanded = target.classList.contains('is-visible');

    if(isExpanded) return;

    this.titles.forEach(title => title.classList.remove('is-visible'));
    this.bodies.forEach(body => body.classList.remove('is-visible'));
    target.classList.add('is-visible');
    if (body) body.classList.add('is-visible');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-product-accordion]').forEach(function(el) {
    new ProductTemplateAccordions(el);
  });

  /* Video hover on product cards */

  const videos = document.querySelectorAll('.box-ratio[data-media-type=video] video');
  
  if(videos.length) {
    videos.forEach(function(video) {
      video.addEventListener('mouseenter', function(e) {
        e.target.play();
      });
      video.addEventListener('mouseleave', function(e) {
        e.target.pause();
      });
    });
  }
});